import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const {
  REQUEST_GET_ALL_SUBMITTED_DOCUMENT,
  SUCCESS_GET_ALL_SUBMITTED_DOCUMENT,
  FAILURE_GET_ALL_SUBMITTED_DOCUMENT,
  LOADER_GET_ALL_SUBMITTED_DOCUMENT,
  GET_START_OF_CARE_DATE_REQUEST,
  REQUEST_GET_ALL_COMPETED_DOCUMENT,
} = documentationActions;

function* getAllSubmittedDocument(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADER_GET_ALL_SUBMITTED_DOCUMENT });
    const response = yield call(templateService.getSubmittedDocuments, action.payload);
    if (response?.status === 200) {
      const isEvalInclude = response?.data?.data?.content?.find((submittedDoc: any) =>
        [
          'EVALUATION_PT',
          'EVALUATION_REFORM_PT',
          'EVALUATION_SLP',
          'EVALUATION_REFORM_OT',
          'EVALUATION_OT',
          'TRANSITIONAL_EVALUATION_PT',
          'TRANSITIONAL_EVALUATION_OT',
          'TRANSITIONAL_EVALUATION_SLP',
          'EVALUATION_REFORM_SLP'
        ].includes(submittedDoc?.formType)
      );
      yield put({ type: SUCCESS_GET_ALL_SUBMITTED_DOCUMENT, payload: response.data });
      if (action.payload?.disciplineChange) {
        const updatedPayload = {
          ...action.payload,
          params: {
            ...action.payload.params,
            filter: 'COMPLETED',
          },
        };
        yield put({
          type: REQUEST_GET_ALL_COMPETED_DOCUMENT,
          payload: updatedPayload,
        });
      }
      if (isEvalInclude) {
        yield put({
          type: GET_START_OF_CARE_DATE_REQUEST,
          payload: {
            submissionId: isEvalInclude?.submissionId,
            param: {
              fromDashboard: false,
              discipline: action.payload?.params?.type,
            },
          },
        });
      }
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_ALL_SUBMITTED_DOCUMENT, payload: error });
  }
}

function* getAllSubmittedDocumetSaga() {
  yield takeEvery(REQUEST_GET_ALL_SUBMITTED_DOCUMENT, getAllSubmittedDocument);
}

export default getAllSubmittedDocumetSaga;
